<template>
  <main-layout :hide-background="true">
    <slot />
  </main-layout>
</template>

<script setup>
import MainLayout from "./MainLayout.vue";
</script>
